import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'auto-editable',
  templateUrl: './t_auto-editable.component.html',
  styleUrls: ['./auto-editable.component.less']
})
export class AutoEditableComponent implements OnInit {

	@Input() value: string;
	@Input() placeholder: string;
  @Input() placeholderInTitle: boolean = true;
	@Input() type: string = 'text';

	@Output() changeValue:EventEmitter<any> = new EventEmitter();
  @Output() cancel:EventEmitter<any> = new EventEmitter();

	@Input() edit:boolean = false;
	savedValue:string;

  constructor() { }

  ngOnInit() {
  }

  get emptyValue()
  {
  	return this.value=="" || this.value==null;
  }

  get titlePlaceholder()
  {
    return this.placeholderInTitle ? this.placeholder+' - ' : ''
  }

  focus()
  {
  	this.savedValue = this.value;
  	this.edit = true;
  }

  blur($event) 
  {
    if(!$event || ($event.code 
        && ($event.code=='Enter' || $event.code=='NumpadEnter') 
        && !$event.shiftKey)) {
      this.edit=false;
      this.changeValue.emit(this.value);
      this.savedValue = '';
      
    } else if(($event && $event.code && $event.code=='Escape')) {
      this.edit = false;
      this.value = this.savedValue;
      this.cancel.emit();
    }
  }

}
